<template>
    <div class="not-found-page">
        <div class="not-found-container">
            <div class="not-found-icon">
                <q-icon name="o_explore_off" size="80px" color="grey-6" />
            </div>
            <h1 class="not-found-code">404</h1>
            <h3 class="not-found-title">Page Not Found</h3>
            <p class="not-found-message">
                The page you're looking for doesn't exist or has been moved.
            </p>
            <div class="not-found-actions">
                <q-btn color="primary" no-caps unelevated label="Go Back" icon="o_arrow_back" @click="this.$router.go(-1)" />
                <q-btn flat no-caps color="primary" label="Home" icon="o_home" @click="this.$router.push({ path: '/' })" />
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: '404-view',
    title: 'Page Not Found'
}
</script>

<style scoped>
.not-found-page {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
}

.not-found-container {
    text-align: center;
    max-width: 420px;
    padding: 2rem;
}

.not-found-icon {
    margin-bottom: 1rem;
}

.not-found-code {
    font-size: 5rem;
    font-weight: 700;
    color: #bdbdbd;
    margin: 0;
    line-height: 1;
}

.not-found-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0.5rem 0;
    color: #424242;
}

.not-found-message {
    color: #757575;
    font-size: 1rem;
    margin: 1rem 0 2rem;
}

.not-found-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
}
</style>
